export default {
  trans: {
    'navbar-sections': {
      about: 'about',
      projects: 'projects',
      blog: 'blog',
    },
    links: {
      github: 'Checkout my GitHub',
      linkedin: 'Checkout my LinkedIn',
      stackoverflow: 'Checkout my StackOverflow',
    },
    footer: {
      'open-source-note': '<0>This website is </0><1> open source</1>.',
    },
  },
};
